import { Component, inject } from '@angular/core';
import { GlobalDropZoneService } from './global-drop-zone.service';

@Component({
  selector: 'app-global-drop-zone-overlay',
  standalone: true,
  template: `
    @if (dropZone.isDragging()) {
      <div class="jl-drop-overlay">
        <!-- Animated background dots -->
        <div class="jl-drop-bg-pattern"></div>

        <!-- Floating decorative elements -->
        <div class="jl-drop-float jl-drop-float--1" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
        </div>
        <div class="jl-drop-float jl-drop-float--2" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
        </div>
        <div class="jl-drop-float jl-drop-float--3" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
        </div>
        <div class="jl-drop-float jl-drop-float--4" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
        </div>

        <!-- Center card -->
        <div class="jl-drop-card">
          <!-- Animated receipt icon -->
          <div class="jl-drop-icon-wrapper">
            <div class="jl-drop-icon-ring"></div>
            <div class="jl-drop-icon-bg">
              <svg class="jl-drop-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/>
                <path d="M8 10h8"/>
                <path d="M8 14h4"/>
              </svg>
            </div>
          </div>

          <h2 class="jl-drop-title">Gider Olarak Yükle</h2>
          <p class="jl-drop-subtitle">Dosyalarınızı bırakarak hızlıca gider kaydı oluşturun</p>

          <!-- File type badges -->
          <div class="jl-drop-badges">
            <span class="jl-drop-badge jl-drop-badge--pdf">
              <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5z"/></svg>
              PDF
            </span>
            <span class="jl-drop-badge jl-drop-badge--img">
              <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/><path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/></svg>
              JPEG
            </span>
            <span class="jl-drop-badge jl-drop-badge--img">
              <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/><path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/></svg>
              PNG
            </span>
          </div>
        </div>

        <!-- Corner dashed borders -->
        <div class="jl-drop-corner jl-drop-corner--tl" aria-hidden="true"></div>
        <div class="jl-drop-corner jl-drop-corner--tr" aria-hidden="true"></div>
        <div class="jl-drop-corner jl-drop-corner--bl" aria-hidden="true"></div>
        <div class="jl-drop-corner jl-drop-corner--br" aria-hidden="true"></div>
      </div>
    }
  `,
  styles: [`
    /* ── Fullscreen overlay ── */
    .jl-drop-overlay {
      position: fixed;
      inset: 0;
      z-index: 55;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(15, 23, 42, 0.35);
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
      pointer-events: none;
      animation: jl-drop-fade-in 0.2s ease-out;
    }

    @keyframes jl-drop-fade-in {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    /* ── Subtle dot pattern ── */
    .jl-drop-bg-pattern {
      position: absolute;
      inset: 0;
      background-image: radial-gradient(rgba(255, 255, 255, 0.08) 1px, transparent 1px);
      background-size: 24px 24px;
    }

    /* ── Corner brackets ── */
    .jl-drop-corner {
      position: absolute;
      width: 3rem;
      height: 3rem;
      border-color: rgba(255, 255, 255, 0.3);
      border-style: dashed;
      border-width: 0;
    }
    .jl-drop-corner--tl { top: 1.5rem; left: 1.5rem; border-top-width: 2px; border-left-width: 2px; border-top-left-radius: 0.75rem; }
    .jl-drop-corner--tr { top: 1.5rem; right: 1.5rem; border-top-width: 2px; border-right-width: 2px; border-top-right-radius: 0.75rem; }
    .jl-drop-corner--bl { bottom: 1.5rem; left: 1.5rem; border-bottom-width: 2px; border-left-width: 2px; border-bottom-left-radius: 0.75rem; }
    .jl-drop-corner--br { bottom: 1.5rem; right: 1.5rem; border-bottom-width: 2px; border-right-width: 2px; border-bottom-right-radius: 0.75rem; }

    /* ── Floating icons ── */
    .jl-drop-float {
      position: absolute;
      color: rgba(255, 255, 255, 0.15);
      animation: jl-drop-float 3s ease-in-out infinite;
    }
    .jl-drop-float svg {
      width: 100%;
      height: 100%;
    }
    .jl-drop-float--1 {
      top: 15%;
      left: 12%;
      width: 2.5rem;
      height: 2.5rem;
      animation-delay: 0s;
    }
    .jl-drop-float--2 {
      top: 20%;
      right: 14%;
      width: 2rem;
      height: 2rem;
      animation-delay: 0.75s;
    }
    .jl-drop-float--3 {
      bottom: 18%;
      left: 16%;
      width: 2.25rem;
      height: 2.25rem;
      animation-delay: 1.5s;
    }
    .jl-drop-float--4 {
      bottom: 22%;
      right: 12%;
      width: 2rem;
      height: 2rem;
      animation-delay: 0.4s;
    }

    @keyframes jl-drop-float {
      0%, 100% { transform: translateY(0); opacity: 0.15; }
      50% { transform: translateY(-10px); opacity: 0.25; }
    }

    /* ── Center card ── */
    .jl-drop-card {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      padding: 2.5rem 3.5rem 2rem;
      background: var(--color-surface-0);
      border: 1px solid var(--color-border);
      border-radius: 1.25rem;
      box-shadow:
        0 20px 48px -12px rgba(4, 23, 71, 0.14),
        0 8px 20px -8px rgba(4, 23, 71, 0.08);
      animation: jl-drop-card-in 0.25s ease-out;
    }

    @keyframes jl-drop-card-in {
      from {
        opacity: 0;
        transform: translateY(12px) scale(0.97);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }

    /* ── Icon ── */
    .jl-drop-icon-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 4.5rem;
      height: 4.5rem;
    }

    .jl-drop-icon-ring {
      position: absolute;
      inset: 0;
      border-radius: 50%;
      border: 2px dashed color-mix(in srgb, var(--color-primary) 30%, transparent);
      animation: jl-drop-spin 8s linear infinite;
    }

    @keyframes jl-drop-spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }

    .jl-drop-icon-bg {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 1rem;
      background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-hover) 100%);
      box-shadow: 0 4px 14px -3px rgba(55, 115, 254, 0.4);
    }

    .jl-drop-icon {
      width: 1.75rem;
      height: 1.75rem;
      color: #fff;
    }

    /* ── Text ── */
    .jl-drop-title {
      margin: 0;
      font-size: 1.25rem;
      font-weight: 650;
      letter-spacing: -0.015em;
      color: var(--color-heading, var(--color-text));
    }

    .jl-drop-subtitle {
      margin: 0;
      font-size: 0.8125rem;
      color: var(--color-text-secondary, #475569);
      text-align: center;
      line-height: 1.5;
    }

    /* ── File type badges ── */
    .jl-drop-badges {
      display: flex;
      gap: 0.5rem;
      margin-top: 0.25rem;
    }

    .jl-drop-badge {
      display: inline-flex;
      align-items: center;
      gap: 0.3rem;
      padding: 0.25rem 0.625rem;
      font-size: 0.6875rem;
      font-weight: 600;
      letter-spacing: 0.02em;
      border-radius: 1rem;
    }

    .jl-drop-badge svg {
      width: 0.75rem;
      height: 0.75rem;
    }

    .jl-drop-badge--pdf {
      background: color-mix(in srgb, #EF4444 12%, var(--color-surface-0));
      color: #DC2626;
      border: 1px solid color-mix(in srgb, #EF4444 20%, transparent);
    }

    .jl-drop-badge--img {
      background: color-mix(in srgb, var(--color-primary) 10%, var(--color-surface-0));
      color: var(--color-primary);
      border: 1px solid color-mix(in srgb, var(--color-primary) 20%, transparent);
    }

    /* ── Dark mode ── */
    :host-context(.theme-dark) .jl-drop-card {
      box-shadow:
        0 20px 48px -12px rgba(0, 0, 0, 0.55),
        0 8px 20px -8px rgba(0, 0, 0, 0.4);
    }

    :host-context(.theme-dark) .jl-drop-bg-pattern {
      background-image: radial-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px);
    }

    /* ── Reduced motion ── */
    @media (prefers-reduced-motion: reduce) {
      .jl-drop-overlay,
      .jl-drop-card,
      .jl-drop-float {
        animation: none;
      }
      .jl-drop-icon-ring {
        animation: none;
      }
    }
  `],
})
export class GlobalDropZoneOverlayComponent {
  protected readonly dropZone = inject(GlobalDropZoneService);
}
